import { useAtomValue } from "jotai";
import { userData } from "./store";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const user = useAtomValue(userData);

  if (user?.token) {
    return <Outlet />;
  }

  return <Navigate to="/" replace />;
};

export default ProtectedRoute;
